import { render, staticRenderFns } from "./AuthHeader.vue?vue&type=template&id=4e068652&scoped=true&"
import script from "./AuthHeader.vue?vue&type=script&lang=js&"
export * from "./AuthHeader.vue?vue&type=script&lang=js&"
import style0 from "../../components/common/css/Auth.css?vue&type=style&index=0&id=4e068652&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e068652",
  null
  
)

export default component.exports